import { Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { Tenant } from '../../context/TenantContext';
import { Badge } from '../../../../shared/components/ui/Badge';
import { useEffect } from 'react';
import { useTenant } from '../../context';

interface TenantTableProps {
  tenants: Tenant[];
  isLoading: boolean;
  onView: (tenant: Tenant) => void;
}

export function TenantTable({ tenants, isLoading, onView }: TenantTableProps) {
  const theme = useTheme();
  const { fetchTenants } = useTenant();
  
  useEffect(() => {
    fetchTenants();
  }, [tenants]);

  const columns = [
    { field: 'name', headerName: 'Razão Social', flex: 1 },
    { field: 'fantasyName', headerName: 'Nome Fantasia', flex: 1 },
    { 
      field: 'documentNumber', 
      headerName: 'CNPJ', 
      width: 160,
      renderCell: (params: any) => (
        <Typography 
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'email', 
      headerName: 'E-mail', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params: any) => (
        <Badge color={params.value === 'active' ? 'success' : 'default'}>
          {params.value}
        </Badge>
      )
    },
  ];

  return (
    <DatabaseTable
      rows={tenants as any}
      columns={columns}
      loading={isLoading}
      onView={onView as any}
      hideDelete
      hideEdit
    />
  );
}